<template>
  <div id="systemFeedback" class="page-wrap">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>数据趋势</el-breadcrumb-item>
        <el-breadcrumb-item>决策参考数据</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          工作量统计
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择月份" :label-width="formLabelWidth">
            <el-date-picker
              size="small" clearable
              v-model="searchformDate"
              type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page2">
      <el-row>
        <el-col :span="24">
          <div id="dayChartLineBox" style="width: 100%;height: 400px;"></div>
        </el-col>
      </el-row>
    </div>

    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          工作内容时间分布
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids2" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择月份" :label-width="formLabelWidth">
            <el-date-picker
              size="small" clearable
              v-model="searchformDate2"
              type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep2()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page2">
      <el-row>
        <el-col :span="24">
          <div id="dayChartLineBox2" style="width: 100%;height: 400px;"></div>
        </el-col>
      </el-row>
    </div>

    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          工作耗时占比
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="打标入库：1个商品/" label-width="170px">
            <el-input size="small" clearable v-model="numOne" placeholder="请输入内容" style="width: 150px;" type="number"></el-input>
          </el-form-item>
          <el-form-item label="违规处理:1个通知/" label-width="160px">
            <el-input size="small" clearable v-model="numTwo" placeholder="请输入内容" style="width: 110px;" type="number"></el-input>
          </el-form-item>
          <el-form-item label="通知处理:1个通知/" label-width="158px">
            <el-input size="small" clearable v-model="numThree" placeholder="请输入内容" style="width: 100px;" type="number"></el-input>
          </el-form-item>
          <el-form-item label="复查处理：1个商品/" label-width="170px">
            <el-input size="small" clearable v-model="numFour" placeholder="请输入内容" style="width: 150px;" type="number"></el-input>
          </el-form-item>
          <el-form-item label="投诉处理：1个商品/" label-width="170px">
            <el-input size="small" clearable v-model="numFive" placeholder="请输入内容" style="width: 100px;" type="number"></el-input>
          </el-form-item>
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids3" placeholder="请选择" size="small" clearable style="width: 160px;" multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择月份" :label-width="formLabelWidth">
            <el-date-picker
              size="small" clearable
              v-model="searchformDate3"
              type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep3()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page2">
      <el-row>
        <el-col :span="24">
          <div id="dayChartLineBox3" style="width: 70%;height: 400px;float: left;"></div>
          <div style="width: 30%;height: 400px;float: left">

            <div style="width: 100%;heigth: 40px;float: left;margin-top: 100px;">
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                打标入库耗时占比
              </div>
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                {{dateProportion.ItemlistProportion}}%
              </div>
            </div>

            <div style="width: 100%;heigth: 40px;float: left">
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                违规处理耗时占比
              </div>
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                {{dateProportion.LowpriceexcelProportion}}%
              </div>
            </div>

            <div style="width: 100%;heigth: 40px;float: left">
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                违规通知耗时占比
              </div>
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                {{dateProportion.NoticeexcelProportion}}%
              </div>
            </div>

            <div style="width: 100%;heigth: 40px;float: left">
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                复查数据处理占比
              </div>
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                {{dateProportion.ReviewclickProportion}}%
              </div>
            </div>

            <div style="width: 100%;heigth: 40px;float: left">
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                平台投诉处理占比
              </div>
              <div style="border: 1px solid #ebeef5;heigth: 40px;text-align: center;line-height: 40px;width: 180px;float: left">
                {{dateProportion.ReportProportion}}%
              </div>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>

    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          工作饱和度排行
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids4" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择月份" :label-width="formLabelWidth">
            <el-date-picker
              size="small" clearable
              v-model="searchformDate4"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep4()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page2">
      <el-table :data="tableData" style="width: 100%;margin-top: 5px;" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column label="排名" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="人员">
        </el-table-column>
        <el-table-column prop="saturation" label="饱和度/月" sortable>
          <template slot-scope="scope">
            {{scope.row.saturation}}%
          </template>
        </el-table-column>
        <el-table-column prop="itemlistnum" label="打标入库占比">
        </el-table-column>
        <el-table-column prop="lowpriceexcelnum" label="违规处理占比">
        </el-table-column>
        <el-table-column prop="noticeexcelnum" label="违规通知占比">
        </el-table-column>
        <el-table-column prop="reviewclicknum" label="复查处理占比">
        </el-table-column>
        <el-table-column prop="reportnum" label="投诉占比">
        </el-table-column>
        <!-- <el-table-column prop="monitoringshopnum" label="操作">
        </el-table-column> -->
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  import echarts from 'echarts';
  export default {
    data() {
      return {
        userids: [],
        userids2: [],
        userids3: [],
        userids4: [],
        statisticalArr: [],
        formLabelWidth: "100px",
        tableLoading:false,
        downTableTrue:false,
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 10,
        searchformDate: '',//时间
        searchformDate2: '',//时间
        searchformDate3: '',//时间
        searchformDate4: [],//时间
        hourArr: [
          '09:00-10:00',
          '10:00-11:00',
          '11:00-12:00',
          '12:00-13:00',
          '13:00-14:00',
          '14:00-15:00',
          '15:00-16:00',
          '16:00-17:00',
          '17:00-18:00'
        ],
        dateProportion: [],
        numOne: 1,
        numTwo: 1,
        numThree: 1,
        numFour: 1,
        numFive: 1,
      }
    },
    mounted() {
      this.getuserinAll()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep4();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep4();
      },
      // 工作量统计
      getuserinAll() {
        fetch({
          url: "hcm/userin/getbyUserid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.statisticalArr = res.data
            this.oneStep()
            this.oneStep2()
            this.oneStep3()
            this.oneStep4()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep() {
        let params = {}
        if (this.searchformDate) {
          params.syncdatemonth = this.$options.filters['fullTime'] (this.searchformDate).substring(0,7)
        }
        if (this.userids.length != 0) {
          params.userids = this.userids.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getUseranalysisAnalyse",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getUseranalysisAnalyse(res.data[0].date[0])
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep2() {
        // this.tableLoading = true
        let params = {}
        if (this.searchformDate2) {
          params.syncdatemonth = this.$options.filters['fullTime'] (this.searchformDate2).substring(0,7)
        }
        if (this.userids2.length != 0 ) {
          params.userids = this.userids2.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getUseranalysisAnalysetime",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getUseranalysisAnalysetime(res.data[0].date)
            // this.tableLoading = false
            // this.tableData = data.content
            // this.totalNum = data.totalElements
          } else {
            // this.tableLoading = false
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep3() {
        let params = {
          numOne: this.numOne,
          numTwo: this.numTwo,
          numThree: this.numThree,
          numFour: this.numFour,
          numFive: this.numFive,
        }
        if (this.searchformDate3) {
          params.syncdatemonth = this.$options.filters['fullTime'] (this.searchformDate3).substring(0,7)
        }
        if (this.userids3.length != 0) {
          params.userids = this.userids3.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getAnalyseProportion",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getAnalyseProportion(res.data[0])
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep4() {
        this.tableLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          numOne: this.numOne,
          numTwo: this.numTwo,
          numThree: this.numThree,
          numFour: this.numFour,
          numFive: this.numFive,
        }
        if (this.searchformDate4) {
          if (this.$options.filters['fullTime'] (this.searchformDate4[0]).substring(0,10) == 'NaN-NaN-Na') {
            params.startsyncdate = ''
          } else {
            params.startsyncdate = this.$options.filters['fullTime'] (this.searchformDate4[0]).substring(0,10);
          }
          if (this.$options.filters['fullTime'] (this.searchformDate4[1]).substring(0,10) == 'NaN-NaN-Na') {
            params.endsyncdate = ''
          } else {
            params.endsyncdate = this.$options.filters['fullTime'] (this.searchformDate4[1]).substring(0,10);
          }
        }
        if (this.userids4.length != 0) {
          params.userids = this.userids4.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getAnalyseSaturation",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableLoading = false
            this.tableData = data.content
            this.totalNum = data.totalElements
          } else {
            this.tableLoading = false
            this.$message.error(res.message)
          }
        })
      },
      // 树状图
      getUseranalysisAnalyse(data) {
        console.log(data)
        this.chartLine1 = echarts.init(document.getElementById('dayChartLineBox'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'category',
            data: ['品牌','入库','打标','违规表格下载数','通知表格下载数','复查表格下载数','投诉商品链接数量'],
            axisTick: {
              alignWithLabel: true
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [
                {
                  value: Number(data.brmnum),
                  itemStyle: {
                    color: '#1890ff'
                  }
                },{
                  value: Number(data.itemlistnum),
                  itemStyle: {
                    color: '#2fc25b'
                  }
                },{
                  value: Number(data.markingnum),
                  itemStyle: {
                    color: '#facc14'
                  }
                },{
                  value: Number(data.lowpriceexcelnum),
                  itemStyle: {
                    color: '#223273'
                  }
                },{
                  value: Number(data.noticeexcelnum),
                  itemStyle: {
                    color: '#8543e0'
                  }
                },{
                  value: Number(data.reviewclicknum),
                  itemStyle: {
                    color: '#13c2c2'
                  }
                },{
                  value: Number(data.reportnum),
                  itemStyle: {
                    color: '#2fc25b'
                  }
                }
              ],
              barWidth : 60,
              type: 'bar',
            }
          ]
        }
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine1.setOption(option);
      },
      // 工作内容时间分布
      getUseranalysisAnalysetime(data) {
        let brmnum = []
        let itemlistnum = []
        let markingnum = []
        let lowpriceexcelnum = []
        let noticeexcelnum = []
        let reviewclicknum = []
        let reportnum = []
        brmnum.push(data[0].brmnum,data[1].brmnum,data[2].brmnum,data[3].brmnum,data[4].brmnum,data[5].brmnum,data[6].brmnum,data[7].brmnum,data[8].brmnum)
        itemlistnum.push(data[0].itemlistnum,data[1].itemlistnum,data[2].itemlistnum,data[3].itemlistnum,data[4].itemlistnum,data[5].itemlistnum,data[6].itemlistnum,data[7].itemlistnum,data[8].itemlistnum)
        markingnum.push(data[0].markingnum,data[1].markingnum,data[2].markingnum,data[3].markingnum,data[4].markingnum,data[5].markingnum,data[6].markingnum,data[7].markingnum,data[8].markingnum)
        lowpriceexcelnum.push(data[0].lowpriceexcelnum,data[1].lowpriceexcelnum,data[2].lowpriceexcelnum,data[3].lowpriceexcelnum,data[4].lowpriceexcelnum,data[5].lowpriceexcelnum,data[6].lowpriceexcelnum,data[7].lowpriceexcelnum,data[8].lowpriceexcelnum)
        noticeexcelnum.push(data[0].noticeexcelnum,data[1].noticeexcelnum,data[2].noticeexcelnum,data[3].noticeexcelnum,data[4].noticeexcelnum,data[5].noticeexcelnum,data[6].noticeexcelnum,data[7].noticeexcelnum,data[8].noticeexcelnum)
        reviewclicknum.push(data[0].reviewclicknum,data[1].reviewclicknum,data[2].reviewclicknum,data[3].reviewclicknum,data[4].reviewclicknum,data[5].reviewclicknum,data[6].reviewclicknum,data[7].reviewclicknum,data[8].reviewclicknum)
        reportnum.push(data[0].reportnum,data[1].reportnum,data[2].reportnum,data[3].reportnum,data[4].reportnum,data[5].reportnum,data[6].reportnum,data[7].reportnum,data[8].reportnum)

        this.chartLine2 = echarts.init(document.getElementById('dayChartLineBox2'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['品牌','入库','打标','违规表格下载数','通知表格下载数','复查表格下载数','投诉商品链接数量']
          },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2','#1890ff'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '品牌',
              data:  brmnum,
              type: 'bar',
            },{
              name: '入库',
              data:  itemlistnum,
              type: 'bar',
            },{
              name: '打标',
              data:  markingnum,
              type: 'bar',
            },{
              name: '违规表格下载数',
              data:  lowpriceexcelnum,
              type: 'bar',
            },{
              name: '通知表格下载数',
              data: noticeexcelnum,
              type: 'bar',
            },{
              name: '复查表格下载数',
              data:  reviewclicknum,
              type: 'bar',
            },{
              name: '投诉商品链接数量',
              data:  reportnum,
              type: 'bar',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine2.setOption(option);
      },
      // 工作耗时占比
      getAnalyseProportion(data) {
        this.dateProportion = data.dateProportion
        console.log(this.dateProportion)
        this.chartLine3 = echarts.init(document.getElementById('dayChartLineBox3'));
        var option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
             name: '工作内容时间分布',
             type: 'pie',
             radius: ['40%', '70%'],
             avoidLabelOverlap: false,
             itemStyle: {
               borderRadius: 10,
               borderColor: '#fff',
               borderWidth: 2
             },
             label: {
               show: false,
               position: 'center'
             },
             emphasis: {
               label: {
                 show: true,
                 fontSize: '20',
                 fontWeight: 'bold'
               }
             },
             labelLine: {
               show: false
             },
             data: [
               { value: data.date[0].brmnum, name: '品牌' },
               { value: data.date[0].itemlistnum, name: '入库' },
               { value: data.date[0].markingnum, name: '打标' },
               { value: data.date[0].lowpriceexcelnum, name: '违规表格下载数' },
               { value: data.date[0].noticeexcelnum, name: '通知表格下载数' },
               { value: data.date[0].reviewclicknum, name: '复查表格下载数' },
               { value: data.date[0].reportnum, name: '投诉商品链接数量' },
             ]
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine3.setOption(option);
      },
    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 28px;
    line-height: 28px;
    background-color: white;
  }
  .page {
    margin: 20px 20px 10px 20px;
    background-color: white;
  }
  .page2 {
    margin: 0px 20px 10px 20px;
    background-color: white;
    padding: 20px;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .widthStyle {
    margin: 0px 0px 15px 10px;
    width: 70%;
  }
</style>
<style lang="scss">
#systemFeedback {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
